import styled from 'styled-components'
import { Colors, FontWeights } from '../constants'

export const Description = styled.div`
  padding: 5px 0px;
  display: flex;
  justify-content: space-between;
  label {
    text-transform: uppercase;
  }
  label:first-child {
    color: ${Colors.Black};
    font-weight: ${FontWeights.Bold};
  }
  label:last-child {
    color: ${Colors.DarkGray};
    font-weight: ${FontWeights.Semibold};
  }
`
